// 分分鐘據點數據
export const locations = [
  // 台北市
  {
    id: 1,
    name: "洲子街美食廣場",
    address: "洲子街美食廣場（Subway旁）",
    city: "台北市",
    region: "台北市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "配合商場營業時間",
    price: "200-400元",
    features: ["AI自動貼膜", "零氣泡", "24小時服務"]
  },
  {
    id: 2,
    name: "微風南山",
    address: "微風南山 B2（海底撈前）",
    city: "台北市",
    region: "台北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["AI自動貼膜", "客製化設計", "現場完成"]
  },
  {
    id: 3,
    name: "環球南港車站",
    address: "環球南港車站B1（1A連通道/奧特拉麵對面）",
    city: "台北市",
    region: "台北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "10:00-22:00",
    price: "200-400元",
    features: ["交通便利", "AI技術", "客製化"]
  },
  {
    id: 4,
    name: "好食城",
    address: "好食城 C棟3F（石研室對面）",
    city: "台北市",
    region: "台北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-21:30",
    price: "200-400元",
    features: ["美食廣場", "便利位置", "快速服務"]
  },
  {
    id: 5,
    name: "內湖家樂福",
    address: "內湖家樂福 1F (Levi's 對面)",
    city: "台北市",
    region: "台北市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["購物便利", "AI貼膜", "停車方便"]
  },
  {
    id: 6,
    name: "凱撒大飯店",
    address: "凱撒大飯店 B1（屯京拉麵對面）",
    city: "台北市",
    region: "台北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-21:00",
    price: "200-400元",
    features: ["高級地段", "品質保證", "專業服務"]
  },

  // 新北市
  {
    id: 7,
    name: "汐止遠雄廣場",
    address: "汐止遠雄廣場1F（寵物公園對面）",
    city: "新北市",
    region: "新北市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["親子友善", "AI技術", "快速服務"]
  },
  {
    id: 8,
    name: "裕隆城",
    address: "裕隆城 5F（TOK 盡興食光 旗艦店對面）",
    city: "新北市",
    region: "新北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["新興商場", "美食聚集", "便利服務"]
  },
  {
    id: 9,
    name: "樹林秀泰2F",
    address: "樹林秀泰2F（Queen Shop前）",
    city: "新北市",
    region: "新北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["影城商場", "娛樂休閒", "一站服務"]
  },
  {
    id: 10,
    name: "樹林秀泰7F",
    address: "樹林秀泰7F（CoCo 壹番屋旁）",
    city: "新北市",
    region: "新北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["高樓層", "景觀佳", "餐飲豐富"]
  },
  {
    id: 11,
    name: "中和家樂福",
    address: "中和家樂福 B1（結帳區對面）",
    city: "新北市",
    region: "新北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["購物中心", "停車便利", "生活機能"]
  },
  {
    id: 12,
    name: "板橋家樂福",
    address: "板橋家樂福 B1",
    city: "新北市",
    region: "新北市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["交通便利", "AI貼膜", "購物方便"]
  },
  {
    id: 13,
    name: "新店家樂福",
    address: "新店家樂福1F(2號門旁)",
    city: "新北市",
    region: "新北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["便利位置", "雙重服務", "停車方便"]
  },
  {
    id: 14,
    name: "北大店家樂福",
    address: "北大店 家樂福B1(手扶梯旁)",
    city: "新北市",
    region: "新北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["學區商圈", "便利服務", "停車充足"]
  },
  {
    id: 15,
    name: "誠品新板店",
    address: "誠品新板店 3F (電梯旁邊)",
    city: "新北市",
    region: "新北市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["文化商場", "AI技術", "品質保證"]
  },
  {
    id: 16,
    name: "淡水家樂福",
    address: "家樂福 淡新店3F",
    city: "新北市",
    region: "新北市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["淡水地區", "AI貼膜", "觀光據點"]
  },
  {
    id: 17,
    name: "遠東百貨板橋中山店",
    address: "遠東百貨 板橋中山店 4F (woosa洋食隔壁)",
    city: "新北市",
    region: "新北市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["百貨公司", "雙重服務", "品質保證"]
  },

  // 桃園市
  {
    id: 18,
    name: "桃園家樂福中壢店",
    address: "桃園家樂福 中壢店1F（石二鍋前面）",
    city: "桃園市",
    region: "桃園市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["中壢核心", "交通便利", "購物方便"]
  },
  {
    id: 19,
    name: "桃園家樂福中原店",
    address: "桃園家樂福 中原店B1（結帳出口對面）",
    city: "桃園市",
    region: "桃園市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["學區商圈", "年輕族群", "活力據點"]
  },
  {
    id: 20,
    name: "桃園置地廣場",
    address: "桃園置地廣場 1F（新光影城）",
    city: "桃園市",
    region: "桃園市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["影城商場", "娛樂中心", "時尚地標"]
  },
  {
    id: 21,
    name: "統領廣場6F",
    address: "統領廣場6F （響泰多前）",
    city: "桃園市",
    region: "桃園市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["購物中心", "AI貼膜", "便利服務"]
  },
  {
    id: 22,
    name: "統領廣場6F客製",
    address: "統領廣場6F （服務台旁）",
    city: "桃園市",
    region: "桃園市",
    service: "3分鐘客製",
    serviceType: "客製",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["客製專區", "設計服務", "現場完成"]
  },
  {
    id: 23,
    name: "統領廣場8F",
    address: "統領廣場8F （原燒日式燒肉旁）",
    city: "桃園市",
    region: "桃園市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["高樓層", "餐飲區", "快速服務"]
  },
  {
    id: 24,
    name: "桃園愛買",
    address: "桃園愛買 2F (停車場賣場入口)",
    city: "桃園市",
    region: "桃園市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:30",
    price: "200-400元",
    features: ["愛買賣場", "停車便利", "雙重服務"]
  },
  {
    id: 25,
    name: "桃園ATT筷食尚",
    address: "桃園ATT筷食尚1F (VV DOUBLE 旁)",
    city: "桃園市",
    region: "桃園市",
    service: "3分鐘客製",
    serviceType: "客製",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["時尚商場", "客製專區", "潮流地標"]
  },

  // 新竹市
  {
    id: 26,
    name: "SOGO巨城3F",
    address: "SOGO巨城3F(NARA對面)",
    city: "新竹市",
    region: "新竹市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["大型商場", "品牌聚集", "便利服務"]
  },
  {
    id: 27,
    name: "SOGO巨城B1",
    address: "SOGO巨城B1(東京純豆腐旁)",
    city: "新竹市",
    region: "新竹市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["地下樓層", "美食區", "雙重服務"]
  },

  // 台中市
  {
    id: 28,
    name: "台中家樂福大墩",
    address: "台中家樂福 大墩B1",
    city: "台中市",
    region: "台中市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["市中心", "購物便利", "停車充足"]
  },
  {
    id: 29,
    name: "台中家樂福青海",
    address: "台中家樂福 青海店B1",
    city: "台中市",
    region: "台中市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["西屯區", "新興商圈", "便民服務"]
  },
  {
    id: 30,
    name: "台中家樂福豐原",
    address: "台中家樂福 豐原店1F",
    city: "台中市",
    region: "台中市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["豐原地區", "雙重服務", "便利購物"]
  },
  {
    id: 31,
    name: "台中家樂福西屯",
    address: "台中家樂福 西屯店 1F",
    city: "台中市",
    region: "台中市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["西屯區", "AI技術", "快速服務"]
  },
  {
    id: 32,
    name: "台中家樂福西屯客製",
    address: "台中家樂福 西屯店 1F (快剪旁邊)",
    city: "台中市",
    region: "台中市",
    service: "3分鐘客製",
    serviceType: "客製",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["客製專區", "設計服務", "現場完成"]
  },
  {
    id: 33,
    name: "台中家樂福文心",
    address: "台中家樂福 文心店 3F",
    city: "台中市",
    region: "台中市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["文心區", "高樓層", "AI貼膜"]
  },
  {
    id: 34,
    name: "台中大買家國光",
    address: "台中大買家 國光店2F",
    city: "台中市",
    region: "台中市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "10:00-22:00",
    price: "200-400元",
    features: ["大買家", "雙重服務", "便利位置"]
  },
  {
    id: 35,
    name: "台中大買家北屯",
    address: "台中大買家 北屯店1F",
    city: "台中市",
    region: "台中市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "10:00-22:00",
    price: "200-400元",
    features: ["北屯區", "一樓便利", "完整服務"]
  },
  {
    id: 36,
    name: "台中火車站",
    address: "台中火車站 鐵鹿大街",
    city: "台中市",
    region: "台中市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "10:00-21:00",
    price: "200-400元",
    features: ["交通樞紐", "觀光景點", "便利位置"]
  },
  {
    id: 37,
    name: "台中麗寶Outlet",
    address: "台中麗寶 Outlet 一期3F（靠近摩天輪）",
    city: "台中市",
    region: "台中市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["outlet購物", "摩天輪", "休閒娛樂"]
  },
  {
    id: 38,
    name: "中友百貨",
    address: "中友百貨A棟 3F（ABC鞋店對面）",
    city: "台中市",
    region: "台中市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["百貨公司", "品牌聚集", "購物中心"]
  },
  {
    id: 39,
    name: "JMALL美食商場",
    address: "JMALL美食商場(服務台旁)",
    city: "台中市",
    region: "台中市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["美食商場", "AI貼膜", "便利服務"]
  },
  {
    id: 40,
    name: "台中新時代",
    address: "台中新時代4F（MO MO壽喜燒）",
    city: "台中市",
    region: "台中市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["新時代廣場", "餐飲區", "完整服務"]
  },

  // 彰化縣
  {
    id: 41,
    name: "彰化家樂福",
    address: "家樂福 B1 (美食街)",
    city: "彰化縣",
    region: "彰化縣",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["彰化地區", "美食街", "AI貼膜"]
  },

  // 苗栗縣
  {
    id: 42,
    name: "苗栗家樂福",
    address: "苗栗家樂福 1F（麥當勞對面）",
    city: "苗栗縣",
    region: "苗栗縣",
    service: "90秒AI貼膜 + 3分鐘客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "貼膜80-150元 / 客製200-400元",
    features: ["苗栗地區", "雙重服務", "便利位置", "停車方便"]
  },

  // 南投縣
  {
    id: 43,
    name: "南投家樂福",
    address: "家樂福2F（手扶梯旁）",
    city: "南投縣",
    region: "南投縣",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["南投地區", "雙重服務", "便利位置"]
  },

  // 雲林縣
  {
    id: 44,
    name: "虎尾家樂福",
    address: "虎尾家樂福1F",
    city: "雲林縣",
    region: "雲林縣",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["虎尾地區", "AI貼膜", "便民服務"]
  },
  {
    id: 45,
    name: "斗六家樂福",
    address: "斗六家樂福B1",
    city: "雲林縣",
    region: "雲林縣",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["斗六地區", "AI技術", "購物便利"]
  },
  {
    id: 46,
    name: "斗南大全聯",
    address: "斗南大全聯1F(廁所前)",
    city: "雲林縣",
    region: "雲林縣",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "08:00-22:00",
    price: "200-400元",
    features: ["斗南地區", "AI貼膜", "全聯超市"]
  },

  // 嘉義市
  {
    id: 47,
    name: "嘉義大潤發",
    address: "嘉義大潤發 B1(哺乳室旁)",
    city: "嘉義市",
    region: "嘉義市",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "08:30-22:30",
    price: "200-400元",
    features: ["嘉義地區", "AI貼膜", "大潤發"]
  },

  // 高雄市
  {
    id: 48,
    name: "義享天地",
    address: "義享天地6F（PUMA旁）",
    city: "高雄市",
    region: "高雄市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["高雄新地標", "時尚購物", "品牌聚集"]
  },
  {
    id: 49,
    name: "SKM草衙道",
    address: "SKM草衙道3F（美食街）",
    city: "高雄市",
    region: "高雄市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["購物中心", "美食聚集", "親子友善"]
  },
  {
    id: 50,
    name: "高雄火車站",
    address: "高雄火車站B3（一番街）",
    city: "高雄市",
    region: "高雄市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "10:00-21:00",
    price: "200-400元",
    features: ["交通樞紐", "地下街", "便利服務"]
  },
  {
    id: 51,
    name: "夢時代",
    address: "夢時代6F(服務處旁)",
    city: "高雄市",
    region: "高雄市",
    service: "貼膜 + 客製",
    serviceType: "雙重服務",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["大型商場", "摩天輪", "海景視野"]
  },
  {
    id: 52,
    name: "巨蛋",
    address: "巨蛋6F（服務處旁）",
    city: "高雄市",
    region: "高雄市",
    service: "3分鐘客製",
    serviceType: "客製",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["巨蛋商場", "客製專區", "體育場館"]
  },

  // 屏東縣
  {
    id: 53,
    name: "屏東家樂福新屏店",
    address: "屏東家樂福 新屏店1F（手扶梯旁）",
    city: "屏東縣",
    region: "屏東縣",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "09:00-22:00",
    price: "200-400元",
    features: ["屏東地區", "AI貼膜", "便利位置"]
  },
  {
    id: 54,
    name: "屏東環球貼膜",
    address: "屏東環球4F（佐丹奴對面）",
    city: "屏東縣",
    region: "屏東縣",
    service: "90秒AI貼膜",
    serviceType: "貼膜",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["環球購物", "AI貼膜", "便利購物"]
  },
  {
    id: 55,
    name: "屏東環球客製",
    address: "屏東環球4F（大創百貨旁）",
    city: "屏東縣",
    region: "屏東縣",
    service: "3分鐘客製",
    serviceType: "客製",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["環球購物", "客製專區", "設計服務"]
  },

  // 宜蘭縣
  {
    id: 56,
    name: "宜蘭金東購物商場",
    address: "宜蘭站前–金東購物商場1F(狂一鍋後面)",
    city: "宜蘭縣",
    region: "宜蘭縣",
    service: "3分鐘客製",
    serviceType: "客製",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["宜蘭地區", "客製專區", "車站商場"]
  },

  // 新增據點
  {
    id: 58,
    name: "桃園ATT筷食尚",
    address: "桃園ATT筷食尚1F (VV DOUBLE 旁)",
    city: "桃園市",
    region: "桃園市",
    service: "3分鐘客製",
    serviceType: "客製",
    hours: "11:00-22:00",
    price: "200-400元",
    features: ["時尚商場", "客製專區", "美食聚集"]
  }
];

// 地區列表
export const regions = [
  "台北市", "新北市", "桃園市", "新竹市", "台中市", 
  "彰化縣", "苗栗縣", "南投縣", "雲林縣", "嘉義市", 
  "高雄市", "屏東縣", "宜蘭縣"
];

// 服務類型
export const serviceTypes = [
  { id: "all", name: "🔧全部服務", color: "bg-purple-500" },
  { id: "貼膜", name: "📱90秒AI貼膜", color: "bg-blue-500" },
  { id: "客製", name: "🎨3分鐘客製手機殼", color: "bg-green-500" },
  { id: "雙重服務", name: "⚡貼膜 + 客製", color: "bg-red-500" }
];
